import React, { useContext } from 'react'
import classNames from 'classnames'
import _ from 'lodash'

import { IBaseProps } from 'browser/components/atomic-elements/atoms/base-props'
import { Avatar } from 'browser/components/atomic-elements/atoms/avatar/avatar'
import { HelpBlock } from 'browser/components/atomic-elements/atoms/help-block/help-block'
import { Label } from 'browser/components/atomic-elements/atoms/label/label'

import { InternalViewContext } from 'browser/contexts/internal-view/internal-view-context'
import { Owner } from 'shared-libs/generated/server-types/entity'
import { renderAuthorHeader, renderEventTimestamp } from '../util'

interface INotificationItemProps extends IBaseProps {
  event: any
  owner: Owner
  index: number
  isFirst: boolean
  isLast: boolean
  workflowEntity: any
}

export const NotificationItem: React.FC<INotificationItemProps> = (props) => {
  const { className, event, owner, isFirst, workflowEntity } = props
  const { createdBy, creationDate, processedDate } = event
  const { showInternals } = useContext(InternalViewContext)

  const plan = _.get(
    workflowEntity,
    'core_storyboard_execution.storyboardPlan.core_storyboard_plan'
  )

  if (_.isEmpty(plan)) {
    return null
  }

  const userDataEvent = event.outputMappings?.find(
    (mapping: { name?: unknown } | null | undefined) => mapping?.name === 'User data event'
  )
  const message = userDataEvent?.value?.message ?? event.details?.name

  if (!message) {
    return null
  }

  const authorName = createdBy?.displayName || 'This user'

  return (
    <div className={classNames('c-timelineEvent', className)} key={event.uniqueId}>
      <div
        className={classNames('c-timelineEvent-line', className, {
          'c-timelineEvent-line--topCutOff': isFirst,
        })}
      />
      <div className="c-timelineEvent-dot" />
      <div className="c-timelineEvent-contentContainer">
        {createdBy && (
          <div className="c-timelineEvent-header">
            <div className="c-timelineEvent-author">
              <Avatar className="c-timelineEvent-avatar" name={createdBy.displayName} size="xs" />
              <Label className="c-timelineEvent-authorName">
                {renderAuthorHeader(createdBy, owner?.firm)}
              </Label>
            </div>
            <HelpBlock className="c-timelineEvent-timestamp">
              {renderEventTimestamp(creationDate, processedDate, showInternals)}
            </HelpBlock>
          </div>
        )}
        <div className="c-timelineEvent-body">
          <p>
            <strong>{authorName}</strong> sent a notification:
          </p>
          <p>
            <strong>{message}</strong>
          </p>
        </div>
      </div>
    </div>
  )
}
